// extracted by mini-css-extract-plugin
module.exports = {"root":"Feature-module--root--3yqCP","content":"Feature-module--content--176Qt","subtitle":"Feature-module--subtitle--3de_y"};